<template>
    <main>
        <crumbs :crumbs="crumbs"></crumbs>
        <div class="wrap">
            <div class="logo"><img :src="require('@/assets/image/77.png')" alt=""></div>
            <div class="list">
                <div class="left item" v-for="item in adv">
                    <div class="bg" :style="{backgroundImage:'url('+item.image+')'}"></div>
                    <div class="mark">
                        <div class="play" @click="showVideo(item)"></div>
                        <div class="element-more title"><span>{{item.title}}</span></div>
                    </div>
                </div>
            </div>
            <div class="data-loading" v-if="show_loading"><loading></loading></div>
        </div>
        <video-float v-if="video_info.title" :video_info="video_info" @hideVideo="hideVideo"></video-float>
    </main>
</template>

<script>
    import Crumbs from "../../../components/pc/Crumbs";
    import VideoFloat from "../../../components/pc/VideoFloat";
    import Loading from "../../../components/pc/Loading";
    export default {
        name: 'brand',
        data() {
            return {
                key:"",
                adv:[
                    {
                        "title":"TL COO走进AWTF EU戴尔基地",
                        "image":"https://dellvideo.smarket.net.cn/22e11cb80dc24c7a9d4fd4acedaf1274/covers/d6dbf796631746b9bbdff484d82362f6-00005.jpg",
                        "video":"https://dellvideo.smarket.net.cn/22e11cb80dc24c7a9d4fd4acedaf1274/fd836344f10c4630b3777c61a0e9f327-4a8d6074597f3b3a27f2d31aa62262ca-ld.mp4",
                    },
                    {
                        "title":"AWTF EU的介绍及对戴尔的感谢",
                        "image":"https://dellvideo.smarket.net.cn/7a17f712ec33450cabdded8094c952d4/covers/d9fb53ba202846a6b17676d5af8ebdca-00005.jpg",
                        "video":"https://dellvideo.smarket.net.cn/7a17f712ec33450cabdded8094c952d4/05516df3b7e243f3bca2562bbe0ca1f2-a3b119248c4325cfd02dc6e3e3effe48-ld.mp4",
                    },
                    {
                        "title":"戴尔对AWTF EU的建设支持",
                        "image":"https://dellvideo.smarket.net.cn/741da5739d63436eb881e9a73985b633/covers/9e03881cc3b04823829b32821240a066-00005.jpg",
                        "video":"https://dellvideo.smarket.net.cn/741da5739d63436eb881e9a73985b633/e95ddee8bb96494395954502f19b3dec-45706430bd2cf45124b3d5de66b80bd4-ld.mp4",
                    },
                    {
                        "title":"AWTF EU成员对戴尔技术的认可",
                        "image":"https://dellvideo.smarket.net.cn/867c09667f034b519bfdcb6fc39b0b6c/covers/6a169188c0244156a58b01a9e865ba0b-00005.jpg",
                        "video":"https://dellvideo.smarket.net.cn/867c09667f034b519bfdcb6fc39b0b6c/2f57e35ea99d4edf8bbf11220a0d2477-0107117760d4a5213abb53efe875087f-ld.mp4",
                    }
                ],
                video_info:{},
                show_loading:false,
            }
        },
        components:{
            Loading,
            Crumbs,VideoFloat

        },
        computed:{
            crumbs() {
                return [
                    {title:"外星人之旅"},
                    {title:"世界级电子竞技设施为Team Liquid提供技术支持"},
                ]
            },
        },
        methods: {
            showVideo(item){
                this.video_info = item;
            },
            hideVideo(){
                this.video_info = {}
            }
        },
        mounted() {
            this.query = this.$route.query;
            this.util.showBottom(true);
        },
        destroyed() {

        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .wrap{background: #f6f6f6;padding: 40px 0 50px;}
    .logo{text-align: center;
        img{width: 500px;}
    }
    .list{overflow: hidden;width: 1200px;margin:40px auto 0;
        .item{width: 590px;height:300px;margin-right:20px;margin-bottom: 20px;position: relative;
            .bg{width: 100%;height:100%;background-repeat: no-repeat;background-position: center center;background-size: cover}
            .mark{position: absolute;top:0;left:0;width: 100%;height:100%;background: rgba(0,0,0,.5);
                .play{width: 60px;height:60px;position: absolute;top:50%;left:50%;background: url("~@/assets/image/4.png") no-repeat left center;background-size: contain;margin-left: -42px;margin-top: -42px; cursor: pointer;}
                .title{position: absolute;bottom:0;left:0;width: 100%;height:50px;line-height: 50px;color:#fff;background: linear-gradient(to bottom,rgba(0,0,0,0),rgba(0,0,0,1));
                    span{padding: 0 20px;}
                }
            }
        }
        .item:nth-child(2n){margin-right: 0;}
    }
</style>

